module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade modal-info-block",
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "id": "modal-2fa"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document",
      "id": "modal-content-2fa"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [(_vm.showCellphone) ? _c('div', [_c('div', {
    staticClass: "form-group info-transfer-box inline"
  }, [_c('p', [_vm._v("Informe o código enviado para:")]), _vm._v(" "), _c('p', {
    staticClass: "bold",
    staticStyle: {
      "letter-spacing": "2px"
    }
  }, [_vm._v(_vm._s(_vm.celFormated))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tokenCellphone),
      expression: "tokenCellphone"
    }],
    staticClass: "inline form-control bold",
    attrs: {
      "type": "text",
      "name": "",
      "maxlength": "6"
    },
    domProps: {
      "value": (_vm.tokenCellphone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tokenCellphone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn option-outline",
    staticStyle: {
      "margin-top": "0.5cm"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.resetSentCellPhone()
      }
    }
  }, [_vm._v("Alterar celular")]), _vm._v(" "), (_vm.errorCell) ? _c('p', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCell))]) : _vm._e(), _vm._v(" "), (_vm.resentCell) ? _c('p', {
    staticClass: "message",
    staticStyle: {
      "margin-top": "0.5cm"
    }
  }, [_vm._v("Código enviado com sucesso!")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.showEmail) ? _c('div', [_c('div', {
    staticClass: "form-group info-transfer-box inline"
  }, [_c('p', [_vm._v("Informe o código enviado para:")]), _vm._v(" "), _c('p', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.emailUser))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tokenEmail),
      expression: "tokenEmail"
    }],
    staticClass: "inline form-control bold",
    staticStyle: {},
    attrs: {
      "type": "text",
      "name": "",
      "maxlength": "6"
    },
    domProps: {
      "value": (_vm.tokenEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tokenEmail = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn option-outline",
    staticStyle: {
      "margin-top": "1cm"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Alterar E-mail")]), _vm._v(" "), (_vm.errorEmail) ? _c('p', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorEmail))]) : _vm._e(), _vm._v(" "), (_vm.resentEmail) ? _c('p', {
    staticClass: "message"
  }, [_vm._v("Código enviado com sucesso!")]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), (_vm.showCellphone) ? _c('div', {
    staticClass: "modal-footer buttons-container"
  }, [_c('button', {
    staticClass: "btn option-outline",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sendCellphone()
      }
    }
  }, [_vm._v("Re-enviar código")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button",
      "disabled": !_vm.tokenCellphone || _vm.tokenCellphone.length != 6
    },
    on: {
      "click": function($event) {
        return _vm.confirmCellphoneOTP()
      }
    }
  }, [_vm._v("Confirmar")])]) : _vm._e(), _vm._v(" "), (_vm.showEmail) ? _c('div', {
    staticClass: "modal-footer buttons-container"
  }, [_c('button', {
    staticClass: "btn option-outline",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sendEmail()
      }
    }
  }, [_vm._v("Re-enviar código")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button",
      "disabled": !_vm.tokenEmail || _vm.tokenEmail.length != 6
    },
    on: {
      "click": function($event) {
        return _vm.confirmEmailOTP()
      }
    }
  }, [_vm._v("Confirmar")])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-36fe3213!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/external/adhesion-confirm-2fa.vue
// module id = 2094
// module chunks = 1